var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { intersection, uniqBy } from 'lodash';
import omit from 'lodash/omit';
import * as React from 'react';
import Checkbox from '../checkbox';
import Icon from '../icon';
import { Styled, StyledPopover } from './style';
var AccordionCheckbox = /** @class */ (function (_super) {
    __extends(AccordionCheckbox, _super);
    function AccordionCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.formatStringtoSnakeCase = function (str) { return str
            .toLowerCase()
            .split(' ')
            .join('_'); };
        _this.callback = function (newFormContent, options) {
            var allContent = newFormContent.flatMap(function (value) { return value.contents.map(function (p) {
                var _a, _b, _c;
                var formatHeader = "" + _this.formatStringtoSnakeCase(value.header);
                if (options && options.section === value.header) {
                    if (options.isCheckallFromHeader) {
                        return _a = {}, _a["" + formatHeader] = true, _a;
                    }
                    return _b = {}, _b[formatHeader + ":" + p.name] = p.checked, _b;
                }
                else if (_this.state.value.length > 0) {
                    return _this.state.value.filter(function (v) { return Object.keys(v)[0] === formatHeader + ":" + p.name || Object.keys(v)[0] === formatHeader; })[0];
                }
                else {
                    return _c = {}, _c[formatHeader + ":" + p.name] = p.checked, _c;
                }
            }); });
            _this.setState({ value: uniqBy(allContent, function (x) { return Object.keys(x)[0]; }) });
            if (_this.props.callback) {
                _this.props.callback({
                    value: uniqBy(allContent, function (x) { return Object.keys(x)[0]; }),
                    formcontent: newFormContent,
                    section: options && options.section && _this.formatStringtoSnakeCase(options.section),
                });
            }
        };
        _this.handleTitleClick = function (index) {
            var activeIndexs = _this.state.activeIndexs;
            if (activeIndexs.find(function (idx) { return idx === index; }) !== undefined) {
                _this.setState({
                    activeIndexs: activeIndexs.filter(function (idx) { return idx !== index; }),
                });
            }
            else {
                _this.setState({ activeIndexs: __spreadArrays(activeIndexs, [index]) });
            }
        };
        _this.filterBySearchQuery = function (formcontent) {
            var searchQuery = _this.props.searchQuery;
            return formcontent
                .flatMap(function (value) { return value.contents.map(function (p) { return value.header.toLowerCase() + ":" + p.name + ":" + p.description; }); })
                .filter(function (value) { return searchQuery ? value.toLowerCase().includes(searchQuery.toLowerCase()) : true; })
                .map(function (value) {
                var splitValue = value.split(':');
                return splitValue[0] + ":" + splitValue[1];
            })
                .reduce(function (result, currentValue) {
                var _a = currentValue.split(':'), section = _a[0], ability = _a[1];
                var currentSection = formcontent.find(function (form) { return form.header.toLowerCase() === section; });
                var currentContent = currentSection && currentSection.contents.find(function (con) { return con.name === ability; });
                var newContent = {
                    header: currentSection && currentSection.header,
                    contents: [
                        {
                            name: ability,
                            checked: currentContent && currentContent.checked,
                            description: currentContent && currentContent.description,
                            warning: currentContent && currentContent.warning,
                            filterOutWarning: currentContent && currentContent.filterOutWarning,
                        },
                    ],
                };
                if (result.find(function (value) { return value.header === newContent.header; })) {
                    var existContent = result.find(function (value) { return value.header === newContent.header; });
                    existContent.contents = existContent.contents.concat(newContent.contents);
                    return result;
                }
                else {
                    return __spreadArrays(result, [newContent]);
                }
            }, []);
        };
        _this.getPermissionsEnableStatus = function (formContent) { return formContent
            .flatMap(function (value) { return value.contents.map(function (con) {
            var _a;
            return (_a = {},
                _a[_this.formatStringtoSnakeCase(value.header) + ":" + con.name] = con.checked,
                _a);
        }); })
            .filter(function (value) { return Object.values(value)[0]; })
            .flatMap(function (value) { return Object.keys(value); }); };
        _this.getWarning = function (_a) {
            var warning = _a.warning, filterOutWarning = _a.filterOutWarning;
            if (!warning) {
                warning = [];
            }
            if (!filterOutWarning) {
                filterOutWarning = [];
            }
            var permissionsEnableStatus = _this.getPermissionsEnableStatus(_this.props.formcontent);
            var warningFiltering = intersection(warning, permissionsEnableStatus);
            if (warningFiltering.length > 0) {
                return {
                    warning: warning.filter(function (warn) { return !permissionsEnableStatus.includes(warn); }),
                    filterOutWarning: filterOutWarning && filterOutWarning.length < 0
                        ? __spreadArrays(filterOutWarning, warningFiltering) : __spreadArrays(warningFiltering),
                };
            }
            return { warning: warning, filterOutWarning: filterOutWarning };
        };
        _this.updateWarningContent = function (_a) {
            var content = _a.content, checked = _a.checked, permissionMapping = _a.permissionMapping;
            var warning = content.warning, filterOutWarning = content.filterOutWarning;
            if (checked === true && warning && warning.length > 0 && warning.includes(permissionMapping)) {
                return {
                    warning: warning.filter(function (warn) { return warn !== permissionMapping; }),
                    filterOutWarning: content.filterOutWarning && content.filterOutWarning.length > 0
                        ? __spreadArrays(content.filterOutWarning, [permissionMapping]) : [permissionMapping],
                };
            }
            else if (checked === false &&
                filterOutWarning &&
                filterOutWarning.length > 0 &&
                filterOutWarning.includes(permissionMapping)) {
                return {
                    warning: warning && warning.length > 0 ? __spreadArrays(warning, [permissionMapping]) : [permissionMapping],
                    filterOutWarning: filterOutWarning.filter(function (warn) { return warn !== permissionMapping; }),
                };
            }
            return {
                warning: warning,
                filterOutWarning: filterOutWarning,
            };
        };
        _this.convertFormfomatToPanel = function (formcontent) {
            var activeIndexs = _this.state.activeIndexs;
            var _a = _this.props, searchQuery = _a.searchQuery, disabled = _a.disabled;
            return formcontent.map(function (form, index) {
                var currentSection = _this.props.formcontent.find(function (value) { return value.header === form.header; });
                var currentContentcheckedFlags = currentSection ? currentSection.contents.map(function (value) { return value.checked; }) : [];
                var isCheckAll = currentContentcheckedFlags.every(Boolean);
                var isUncheckAll = currentContentcheckedFlags.every(function (value) { return value === false; });
                return {
                    onTitleClick: function (e, data) {
                        _this.handleTitleClick(data.index);
                    },
                    title: {
                        key: "title-" + index,
                        icon: React.createElement(Icon, { name: "arrow-right" }),
                        active: searchQuery || activeIndexs.includes(index),
                        content: (React.createElement("div", { key: "content-header-" + index },
                            form.subHeader
                                ? React.createElement("div", { className: "header-container" },
                                    React.createElement("div", { className: "header" }, form.header),
                                    React.createElement("div", { className: "sub-header" }, form.subHeader))
                                : React.createElement("div", null, form.header),
                            React.createElement(Checkbox, { key: "checkbox-" + index, disabled: disabled, mini: true, checked: isCheckAll, indeterminate: isUncheckAll ? false : !isCheckAll, onClick: function (e) {
                                    e.stopPropagation();
                                }, onChange: function () {
                                    var newFormContent = _this.props.formcontent.map(function (value) {
                                        if (value.header === form.header) {
                                            if (isUncheckAll) {
                                                var checkAllContent = __assign(__assign({}, value), { contents: value.contents.map(function (content) { return (__assign(__assign({}, content), { checked: true })); }) });
                                                return checkAllContent;
                                            }
                                            var unCheckAllContent = __assign(__assign({}, value), { contents: value.contents.map(function (content) { return (__assign(__assign({}, content), { checked: false })); }) });
                                            return unCheckAllContent;
                                        }
                                        return value;
                                    });
                                    var permissionsEnableStatus = _this.getPermissionsEnableStatus(newFormContent).map(function (enablePermission) { return _this.formatStringtoSnakeCase(enablePermission); });
                                    newFormContent = newFormContent.map(function (formContent) {
                                        var contents = formContent.contents.map(function (content) {
                                            var warningFiltering = content.warning
                                                ? intersection(content.warning, permissionsEnableStatus)
                                                : [];
                                            if (isUncheckAll) {
                                                content.warning = content.warning
                                                    ? content.warning.filter(function (warn) { return !permissionsEnableStatus.includes(warn); })
                                                    : [];
                                                content.filterOutWarning = content.filterOutWarning
                                                    ? __spreadArrays(content.filterOutWarning, warningFiltering) : __spreadArrays(warningFiltering);
                                            }
                                            else {
                                                var filterOutWarning = content.filterOutWarning &&
                                                    content.filterOutWarning.filter(function (fw) { return !fw.includes(form.header.toLowerCase()); });
                                                var warning = content.filterOutWarning
                                                    ? content.filterOutWarning.filter(function (fw) { return fw.includes(form.header.toLowerCase()); })
                                                    : [];
                                                content.filterOutWarning = filterOutWarning;
                                                content.warning = content.warning ? __spreadArrays(content.warning, warning) : [];
                                            }
                                            return content;
                                        });
                                        return __assign(__assign({}, formContent), { contents: contents });
                                    });
                                    _this.callback(newFormContent, { isCheckallFromHeader: isUncheckAll, section: form.header });
                                } }))),
                    },
                    content: {
                        key: "content-" + index,
                        active: searchQuery || activeIndexs.includes(index),
                        content: (React.createElement("div", { key: "custom-content-" + index, className: "custom-content" }, form.contents.map(function (con, idx) {
                            if (con.warning && con.warning.length > 0) {
                                var _a = _this.getWarning({
                                    warning: con.warning,
                                    filterOutWarning: con.filterOutWarning,
                                }), warning = _a.warning, filterOutWarning = _a.filterOutWarning;
                                con.warning = warning;
                                con.filterOutWarning = filterOutWarning;
                            }
                            return (React.createElement("div", { key: con.name + "-" + index + "-" + idx },
                                React.createElement("div", { className: "text-wrapper" },
                                    React.createElement("div", { className: "name-section" },
                                        React.createElement("div", { className: "name" }, con.name),
                                        con.checked === true && con.warning && con.warning.length > 0 && (React.createElement(StyledPopover, { trigger: React.createElement(Icon, { name: "info" }), content: React.createElement("div", null,
                                                "This permission may not work properly unless",
                                                ' ',
                                                React.createElement("strong", null, con.warning.length === 1 ? con.warning[0] : con.warning.join(', ')),
                                                ' ',
                                                con.warning.length === 1 ? 'is' : 'are',
                                                " also enabled."), position: "top left" }))),
                                    con.description && React.createElement("div", { className: "description" }, con.description)),
                                React.createElement(Checkbox, { disabled: disabled, mini: true, onChange: function (e, data) {
                                        var section = '';
                                        var newFormContent = _this.props.formcontent.map(function (value) {
                                            var permissionMapping = (data.name && _this.formatStringtoSnakeCase(data.name)) + ":" + data.value;
                                            if (value.header === form.header) {
                                                section = value.header;
                                                return __assign(__assign({}, value), { contents: value.contents.map(function (content) {
                                                        var checked = data.checked || false;
                                                        if (content.name === data.value) {
                                                            return __assign(__assign({}, content), { checked: checked });
                                                        }
                                                        var _a = _this.updateWarningContent({
                                                            content: content,
                                                            checked: checked,
                                                            permissionMapping: permissionMapping,
                                                        }), warning = _a.warning, filterOutWarning = _a.filterOutWarning;
                                                        content.warning = warning;
                                                        content.filterOutWarning = filterOutWarning;
                                                        return __assign({}, content);
                                                    }) });
                                            }
                                            return __assign(__assign({}, value), { contents: value.contents.map(function (content) {
                                                    var _a = _this.updateWarningContent({
                                                        content: content,
                                                        checked: data.checked || false,
                                                        permissionMapping: permissionMapping,
                                                    }), warning = _a.warning, filterOutWarning = _a.filterOutWarning;
                                                    content.warning = warning;
                                                    content.filterOutWarning = filterOutWarning;
                                                    return __assign({}, content);
                                                }) });
                                        });
                                        _this.callback(newFormContent, { section: section });
                                    }, checked: con.checked, name: form.header, value: con.name })));
                        }))),
                    },
                };
            });
        };
        _this.state = {
            activeIndexs: [],
            value: [],
        };
        return _this;
    }
    AccordionCheckbox.prototype.render = function () {
        var _a = this.props, formcontent = _a.formcontent, searchQuery = _a.searchQuery;
        var panels = this.convertFormfomatToPanel(formcontent);
        if (searchQuery) {
            panels = this.convertFormfomatToPanel(this.filterBySearchQuery(formcontent));
        }
        var props = omit(this.props, ['formcontent', 'callback', 'disabled', 'searchQuery']);
        return React.createElement(Styled, __assign({ panels: panels }, props));
    };
    return AccordionCheckbox;
}(React.Component));
export default AccordionCheckbox;
//# sourceMappingURL=index.js.map